import { Injectable } from "@angular/core";
import { IntegrationServiceAbstract } from "projects/alden-extension/src/lib/services/integration-service/integration-service-abstract";
import { UdeuService } from "./udeu.service";
import { SMTDataListsService } from "projects/alden-extension/src/lib/services/data-lists.service";
import { GaudeSubdivisionNominal } from "../model/classes/gaude-subdivision-nominal";
import { ThumbnailService } from "@alfresco/adf-core";

@Injectable({
  providedIn: 'root'
})
export class IntegrationServiceImpl extends IntegrationServiceAbstract { 

  constructor(dataListsService: SMTDataListsService, private udeuService: UdeuService, thumbnailService: ThumbnailService) {
    super(dataListsService,thumbnailService);
  }

  override getDataListElements(key: string, dataListName: any): Promise<any> {
    if(key === "properties.udeu:nominalSubdivision" || key === "properties.udeu:tcStructure") {
      return this.udeuService.getGaudeDataListValues(dataListName).then((res: GaudeSubdivisionNominal) => Promise.resolve(res.items.map((element) => {
        return {key: element.id_subdivision, value: element.subdivision_archivo}
      })));
    } else {
      return this.dataListsService.getDataListValues(dataListName);
    }
  }

}